export default function TimeIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2328_6334)">
        <path
          d="M8.00065 1.33325C6.23254 1.33325 4.53685 2.03563 3.28661 3.28587C2.03636 4.53612 1.33398 6.23181 1.33398 7.99992C1.33398 9.76803 2.03636 11.4637 3.28661 12.714C4.53685 13.9642 6.23254 14.6666 8.00065 14.6666C9.76876 14.6666 11.4645 13.9642 12.7147 12.714C13.9649 11.4637 14.6673 9.76803 14.6673 7.99992C14.6673 6.23181 13.9649 4.53612 12.7147 3.28587C11.4645 2.03563 9.76876 1.33325 8.00065 1.33325V1.33325Z"
          stroke="#808285"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 4V8L10.6667 9.33333"
          stroke="#808285"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2328_6334">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
